module.exports = __webpack_public_path__ + "static/media/erv.759eb51f.jpg";